import { Box, Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material'

export interface FuturesEvidencePanelProps {
  title: string
  accessLabel: string
  accessTarget: string
  description: string
  evidence: string[]
  actions?: string[]
  notes?: string[]
  children?: React.ReactNode
}

export default function FuturesEvidencePanel({
  title,
  accessLabel,
  accessTarget,
  description,
  evidence,
  actions = [],
  notes = [],
  children,
}: FuturesEvidencePanelProps) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Box>
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Access caption: {accessLabel} - {accessTarget}
        </Typography>
      </Box>

      <Typography variant="body2">{description}</Typography>

      {actions.length > 0 && (
        <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap">
          {actions.map((action) => (
            <Button key={action} size="small" variant="outlined" disabled sx={{ textTransform: 'none' }}>
              {action}
            </Button>
          ))}
        </Stack>
      )}

      {children}

      <Card variant="outlined" sx={{ bgcolor: 'background.default' }}>
        <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.75 }}>
            Access evidence
          </Typography>
          <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap">
            {evidence.map((file) => (
              <Chip key={file} label={file} size="small" variant="outlined" />
            ))}
          </Stack>
        </CardContent>
      </Card>

      {notes.length > 0 && (
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
            Implementation notes
          </Typography>
          <Stack spacing={0.5}>
            {notes.map((note) => (
              <Typography key={note} variant="body2" color="text.secondary">
                - {note}
              </Typography>
            ))}
          </Stack>
        </Box>
      )}
    </Box>
  )
}
